import { cn } from '@/lib/cn';
import { useProfilePhoto } from '@/features/account/use-profile-photo';

/** The person's picture, or the first letter of their name when they have not added one. */
export function Avatar({ name, className }: { name: string; className?: string }) {
  const photo = useProfilePhoto();
  if (photo) {
    return (
      <img
        src={photo}
        alt=""
        className={cn('size-8 shrink-0 rounded-full object-cover', className)}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid size-8 shrink-0 place-items-center rounded-full bg-primary-tint font-display text-small font-bold text-primary-hover',
        className,
      )}
    >
      {name.slice(0, 1).toUpperCase()}
    </span>
  );
}
